module.exports = __webpack_public_path__ + "img/logo-full-white.cf429f9d.png";